var map = {
	"./bilibili.svg": "8ea4",
	"./instagram.svg": "8d62",
	"./pause.svg": "b849",
	"./play.svg": "4c1a",
	"./weibo.svg": "21c7",
	"./xiaohongshu.svg": "09a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";